module.exports = __webpack_public_path__ + "img/close.2884bec4.png";